import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_PROVIDERS_QUERY from './GetProviders.gql';

const parseResult = result => {
  const initialState = {
    providers: [],
  };

  const providers = get(result, 'core.providerInformation');

  return {
    ...initialState,
    ...providers,
  };
};

export const useProvidersQuery = options => {
  const [queryResult, queryAction] = useQuery(GET_PROVIDERS_QUERY, {
    ...options,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
